<template>
    <section class="section-table">
        <pagination
            class="pagination-top"
            :total="applicationHistory.total"
            :page.sync="applicationHistory.current_page"
            :limit.sync="applicationHistory.per_page"
            @pagination="getApplicationHistory(false)"
            @sizeChange="getApplicationHistory(true)"
            :separate-change="true"
            :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
            :slotStacked="true"
            slotPosition="before"
        >
            <section class="w-100 d-flex flex-column">
                <div class="w-100 d-flex justify-content-between mb-3">
                    <el-button class="mr-2" type="primary" @click="toggleFilters()" size="small" icon="fas fa-filter">
                        Filters
                    </el-button>
                    <el-input clearable style="margin-left: 10px" size="small" v-model="search"
                              placeholder="Search Messages"></el-input>
                    <el-date-picker
                        style="margin-left: 10px; width: 750px"
                        v-model="filterDate"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="To"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        align="right"
                        size="small"
                    ></el-date-picker>
                    <el-button style="margin-left: 10px" size="small" type="primary"
                               @click="getApplicationHistory(true)">
                        Reload History
                    </el-button>
                </div>

                <transition name="slide">
                    <x-panel margin v-show="showFilters">
                        <div slot="title" class="w-100 d-flex align-items-center mx-0">
                            <h3>Filter By:</h3>
                            <!-- filter by application history type -->
                            <div class="m-2">
                                <el-select
                                    v-model="applicationHistoryTypes"
                                    multiple
                                    class=""
                                    clearable
                                    @change="filter"
                                    @clear="filter"
                                    :loading="tableLoading"
                                    reserve-keyword
                                    placeholder="Filter By History Type"
                                    size="small"
                                >
                                    <el-option-group label="Application Type">
                                        <el-option
                                            v-for="(applicationType, name) in applicationTypes"
                                            :key="name"
                                            :label="applicationType"
                                            :value="name"
                                        ></el-option>
                                    </el-option-group>
                                </el-select>
                            </div>
                        </div>
                    </x-panel>
                </transition>
            </section>
        </pagination>

        <el-table
            ref="tableView"
            border
            v-loading="tableLoading"
            :data="tableData"
            style="width: 100%">
            <el-table-column sortable prop="message" label="Message">
                <template slot-scope="scope">
                    <span v-html="scope.row.message"></span>
                </template>
            </el-table-column>
            <el-table-column sortable prop="user.full_name" label="User" width="300">
                <template slot-scope="scope">
                    {{ _.get(scope, "row.user.full_name", "Unknown") }}
                </template>
            </el-table-column>
            <el-table-column sortable prop="created_at" label="Created" width="200"
                             :formatter="formatDate"></el-table-column>
        </el-table>

        <pagination
            class="pagination-bottom"
            :total="applicationHistory.total"
            :page.sync="applicationHistory.current_page"
            :limit.sync="applicationHistory.per_page"
            @pagination="getApplicationHistory(false)"
            @sizeChange="getApplicationHistory(true)"
            :separate-change="true"
            :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
            :slotStacked="true"
            slotPosition="after"
        >
            <section class="w-100">
                <div class="w-100 d-flex justify-content-between">
                    <el-input clearable style="margin-left: 10px" size="small" v-model="search"
                              placeholder="Search Messages"></el-input>
                    <el-date-picker
                        style="margin-left: 10px; width: 750px"
                        v-model="filterDate"
                        type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="To"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        align="right"
                        size="small"
                    ></el-date-picker>
                    <el-button style="margin-left: 10px" size="small" type="primary"
                               @click="getApplicationHistory(true)">
                        Reload History
                    </el-button>
                </div>
            </section>
        </pagination>
    </section>
</template>

<script>
import {mapGetters} from "vuex"
import Pagination from "@shared/components/pagination"

export default {
    name: "HistoryEvent",

    components: {
        Pagination,
    },

    data() {
        return {
            tableLoading: true,
            applicationHistory: [],
            search: "",
            searchTimeout: null,
            searchTimeoutWait: 1000,
            filterDate: [],
            showFilters: false,
            loading: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: "Last week",
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit("pick", [start, end])
                        },
                    },
                    {
                        text: "Last month",
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit("pick", [start, end])
                        },
                    },
                    {
                        text: "Last 3 months",
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit("pick", [start, end])
                        },
                    },
                ],
            },
            applicationTypes: {
                null: 'All History',
                call: 'Call History',
                customer_signature: 'Customer Signature History',
                email: 'Email History',
                lead_assigned: 'Lead Assigned history',
                lead_assigned_updated: 'Lead Assigned Updated History',
                lead_created: 'Lead Created History',
                lender_submissions: 'Lender Submission History',
                status_changed: 'Status Changed History',
                take_control: 'Take Control History',
                min_max_rate: 'Min Max History'
            },
            applicationHistoryTypes: []
        }
    },

    computed: {
        ...mapGetters({
            user: "user/user",
        }),
        tableData() {
            if (_.isEmpty(this.applicationHistory.data)) return
            return this.applicationHistory.data.filter((history) => !this.isNumeric(history.message))
        },
        filterDateRange() {
            if (_.isEmpty(this.filterDate)) return false
            return this.filterDate
        },
        searchOptions() {
            return this.applicationTypes.reduce((selected, role) => {
                if (this.applicationHistoryTypes.includes(role.id))
                    selected.push(role)
                return selected
            }, [])
        }
    },

    mounted() {
        this.getApplicationHistory(true)
    },

    methods: {
        isNumeric(value) {
            return /^-?\d+$/.test(value);
        },
        formatDate(row, column, value, index) {
            if (value) return this.$moment.utc(value).tz(this.user.timezone).format("ddd DD/MM/YY LT")
            else return null
        },
        getApplicationHistory(resetPage) {
            this.tableLoading = true

            if (resetPage) {
                this.applicationHistory.current_page = 1
            }

            let data = {
                page: this.applicationHistory.current_page,
                per_page: this.applicationHistory.per_page,
                search: this.search,
                filterDateRange: this.filterDateRange,
                applicationHistoryTypes: this.applicationHistoryTypes
            }

            axios
                .post("/api/application/" + applicationId + "/get-application-history", data, {
                    headers: {Authorization: "Bearer " + this.$store.getters.token},
                })
                .then((res) => {
                    this.applicationHistory = res.data
                    this.tableLoading = false
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        toggleFilters() {
            this.showFilters = !this.showFilters
        },
        filter() {
            this.loading = true
            let tableView = this.$refs.tableView
            if (tableView) tableView.clearSelection()
            this.getApplicationHistory(true)
        },
    },
    watch: {
        search: {
            handler() {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.getApplicationHistory(true)
                }, this.searchTimeoutWait)
            },
        },
        filterDateRange: {
            handler() {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.getApplicationHistory(true)
                }, this.searchTimeoutWait)
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.section-table {
    background-color: #f0f3f5;
    border: 1px solid #c2cfd6;
    padding: 10px;

    > > > .pagination-container {
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        padding: 10px !important;

        &.pagination-top {
            margin-bottom: 10px !important;
        }

        &.pagination-bottom {
            margin-top: 10px !important;
            margin-bottom: 0 !important;
        }

        .el-pager {
            li {
                background-color: transparent;
                border: 1px solid #dcdfe6;
                font-weight: 400;

                &.active {
                    background-color: #69c23a;
                    border: none;
                }
            }
        }
    }

    > > > .el-table {
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .el-table__row {
            cursor: pointer;

            &.account-suspended {
                td,
                th {
                    .el-dropdown {
                        .el-button {
                            background: red;
                            color: #ffffff !important;
                        }
                    }
                }
            }
        }

        .el-table__expanded-cell {
            background: #ffffff;
            box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.7) inset;
        }

        .cell {
            word-break: break-word;
        }
    }
}
</style>
